export default "__VITE_ASSET__DzMZ08DR__"